import CreateServiceRequest from '../../../components/CreateServiceRequest/CreateServiceRequest';

const CreateMultipleServiceRequest = () => <CreateServiceRequest />;

export default CreateMultipleServiceRequest;
